import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 * This component should wrap the content that you wish to use as the base layer. All overlayed elements will be atop this element.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function PositionedOverlayBase(_ref) {
  let {
    children,
    className,
    ...rest
  } = _ref;
  const rootClassName = clsx({
    'positioned-overlay-base': true
  }, className);
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "positionedOverlayBase",
    className: rootClassName,
    ...rest,
    children: children
  });
}
export default PositionedOverlayBase;